'use strict';

var NewCalibrationAnalysisToolbarController = function NewCalibrationAnalysisToolbarController($scope) {
  $scope.closeNewCalibrationAnalysis = function () {
    $scope.screenState.newPageVisible === true ? $scope.$emit('online-logit-calibration:back-to-calibration-screen') : $scope.$broadcast('online-logit-calibration:show-unsaved-dialog');
  };
};
NewCalibrationAnalysisToolbarController.$inject = ['$scope'];
module.exports = NewCalibrationAnalysisToolbarController;